import axios from 'axios'
import store from '@/store';
import router from '@/router/index'
import { BASE_URL } from '@/utils/define';
import {Message} from 'view-design';
// 表示是否退出登录
let loginOutFlag = false;
const service = axios.create({
  // 设置基础url
  baseURL: BASE_URL,
  headers: {'Content-Type': 'application/json;charset=UTF-8'},
  timeout: 10000,
})
/**
 * @author lihh
 * @description 共同的处理 使用同步
 * @param {*} url 
 * @param {*} data 
 * @return 返回一个promise
 */
function commonApi(url, data) {
    try {
      // let res = axios({url, method: 'post', data});
      return new Promise((resolve) => {
        service.post(url, data).then(res => {
          resolve(res);
        })
      })
    } catch (err) {

      Message.error('服务器出错')
      console.log(err)
    }
}

/**
 * @author lihh
 * @description 进行token验证
 */
export default async function VerifyToken() {

    // 获取token
    const token = store.getters.token;
    // 判断如果token为空 直接返回
    if (!token || token === '') return false;
  
    // 进行请求
    let res = await commonApi(BASE_URL + '/hpo/Oauth/VerifyToken', {token});

    // 判断token是否有效
    if (!res.data) {
      await refreshTokenMake();
    } else {
        return Promise.resolve();
    }
}

 
/**
 * @author lihh
 * @description 根据长token  对短token进行刷新
 */
async function refreshTokenMake() {

    // 获取刷新token
    let refreshToken = store.getters.refreshToken;
  
    // 进行请求
    let res = await commonApi(BASE_URL + '/hpo/Oauth/RefreshToken', {refreshToken});

    // 判断token是否获取成功
    if (res.data.code =='200') {
  
      // 设置vue的值
      store.dispatch('_token', res.data.data);
      return Promise.resolve();
  
    } else {
  
        if (loginOutFlag) return false;
        loginOutFlag = true;
        // 清除token的值 跳转到登录页面 1s后清除判断
        let timer = setTimeout(() => {

            loginOutFlag = false;
            clearTimeout(timer);
        }, 1000);
        store.dispatch('_tokenFlag', '');
        store.dispatch('_headerNav', 'homePage');
        store.dispatch('_personalCenterNav', 'myInfo');
        store.dispatch('_skipSwitch', '1');
        store.dispatch('_userName', '');
        store.dispatch('_portraitPath', '');
        router.push('/');

        // 删除聊天缓存
        localStorage.removeItem('userInfo');
        Message.success('登录过期,请重新登录');
    }
}


// WEBPACK FOOTER //
// ./src/utils/tokenCheck.js